/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RadarSubmitOrderResponse = {
    parent_order_id: string;
    submit_status: RadarSubmitOrderResponse.submit_status;
    broker_order_id: (string | null);
    rejection_reason: (string | null);
};
export namespace RadarSubmitOrderResponse {
    export enum submit_status {
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        SUBMIT_ATTEMPTED = 'SUBMIT_ATTEMPTED',
    }
}

